import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c1602b2a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=c1602b2a&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=c1602b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1602b2a",
  null
  
)

export default component.exports